<div class="grid ac-tips-grid" *ngIf="numberOfTips">
	<div class="row justify-content-between">
		<div class="col-17 col-md-24 col-sm-24">
			<div class="slider-container">
				<div class="slider" (pan)="onPan($event)" [style.width]="numberOfTips * 100 + '%'" #slider>
					<div class="tip-page slider-panel" *ngFor="let tipPrefix of tipsPrefixes; let pageIndex = index" [attr.data-cy]="'ac-tips-page-' + pageIndex">
						<div class="tip-page-header">
							<h2
								class="text-18-bold tip-header"
								*dcrIfExists="tipPrefix + '_TITLE'; default: false"
								[dcrHTMLKey]="tipPrefix + '_TITLE'"
								[attr.data-cy]="'ac-tips-page-' + pageIndex + '-title'"
							></h2>
							<p
								*dcrIfExists="tipPrefix + '_SUBTITLE'; default: false"
								[dcrHTMLKey]="tipPrefix + '_SUBTITLE'"
								[attr.data-cy]="'ac-tips-page-' + pageIndex + '-subtitle'"
							></p>
						</div>

						<div class="tip-page-content">
							<ng-container *dcrIfExists="tipPrefix + '_VIDEO'; default: false">
								<cwp-video-player [videoId]="'' | dcr: tipPrefix + '_VIDEO'"></cwp-video-player>
							</ng-container>
							<ng-container *dcrIfExists="tipPrefix + '_CONTENT'; default: false">
								<div [dcrHTMLKey]="tipPrefix + '_CONTENT'" [attr.data-cy]="'ac-tips-page-' + pageIndex + '-content'"></div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="carousel" *ngIf="numberOfTips > 1" data-cy="ac-tips-carousel">
					<icon class="carousel-svg-icon" type="angle-left" viewBox="590 350 610 1230" (click)="slideToPage(currentTipIndex - 1)"></icon>

					<div
						*ngFor="let _ of [].constructor(numberOfTips); let pageIndex = index"
						class="carousel-dot"
						[class.active]="pageIndex === currentTipIndex"
						(click)="slideToPage(pageIndex)"
					></div>
					<icon class="carousel-svg-icon" type="angle-right" viewBox="590 350 610 1230" (click)="slideToPage(currentTipIndex + 1)"></icon>
				</div>
			</div>
		</div>
		<div id="tips-sidebar" class="col-7 col-md-24 col-sm-24" [ngClass]="{ 'sidebar-container': tipsSidebar.children.length !== 0 }" #tipsSidebar>
			<ng-content></ng-content>
		</div>
	</div>
</div>
